export const ReferencesData = [
  {
    id: 1,
    name: "Tanjida Rahman",
    es: {
      title:
        "Curadora de Personas | Creadora de Café | Facilitadora de Información Cualitativa Humana en Sonar",
      workRelation: "Compañero de Equipo",
      referenceText:
        "Sergio es un colega fantástico, servicial e perspicaz. Durante nuestro tiempo juntos en YourWatches, fue quien me incorporó a la empresa. Es confiable y experto en Excel y otros programas de oficina. Es genial en ventas y atención al cliente porque puede conectar con los clientes de manera muy natural. Tiene una gran ética de trabajo y siempre se esfuerza por hacer lo mejor. Como persona, es cálido y amable. Cualquier empresa u organización se beneficiaría al tenerlo en su equipo.",
    },
    title:
      "Curator of People | Brewer of Coffee | Enabling Qualitative Human Insights @ Sonar",
    workRelation: "Teamate",
    linkedinProfile: "https://www.linkedin.com/in/tanjida-rahman-151815122/",
    image: "tj",
    referenceText:
      "Sergio is a fantastic colleague, helpful and insightful. During our shared time at YourWatches, he was the one who did my onboarding into the company. He is reliable and well versed in excel and other office suite programs. He is great at sales and customer service because he can connect with customers very naturally. He has great work ethic and always strives to do his best. As a person, he is warm and kind. Any company and/ or organization would benefit from having him on their team.",
  },
  {
    id: 2,
    name: "Mariela Carrizo",
    es: {
      title: "RRHH",
      workRelation: "Compañero de Equipo",
      referenceText:
        "Sergio ha sido mi sucesor en la posición de compras en Ormay, demostrando atención, disposición y compromiso para aprender y desarrollarse en el cargo. Recomendaría a Sergio para cualquier trabajo que requiera habilidades analíticas, organización y responsabilidad. Es una persona amable y bondadosa que facilita un ambiente de trabajo positivo.",
    },
    title: "RRHH",
    workRelation: "Teamate",
    linkedinProfile: "https://www.linkedin.com/in/marielacarrizo/",
    image: "maru",
    referenceText:
      "Sergio has been my successor in the purchasing position at Ormay, demonstrating attention, willingness, and commitment to learning and developing in the role. I would recommend Sergio for any job that requires analytical skills, organization, and responsibility. He is a friendly and kind person who facilitates a positive work environment.",
  },
  {
    id: 3,
    name: "Alvaro Gonzalez",
    es: {
      title: "Especialista en Costos, Licenciado en Administración de Empresas",
      workRelation: "Gerente",
      referenceText:
        "Desde que se unió al equipo, se comprometió con nuestras tareas. Aprendió detalles rápidamente y mejoró procesos. Reconoció aspectos importantes y siguió sus deberes de manera proactiva. Ha forjado sólidas relaciones interpersonales y tiene un gran sentido del humor. Soy afortunado de poder compartir tiempo con él. Su profesionalismo y disposición para mejorar lo distinguen como un gran compañero de trabajo.",
    },
    title: "Cost specialist, Bachelor of Business Administration",
    workRelation: "Manager",
    linkedinProfile: "https://www.linkedin.com/in/alvaro-gonzalez-21161518/",
    image: "alvaro",
    referenceText:
      "Since he joined the team, he was committed to our tasks. He learned details quickly and improved processes. He recognized important aspects and tracked his duties in a proactive way. He has forged strong interpersonal relationships and has a great sense of humor. I am lucky to be able to share time with him. His professionalism and willingness to improve set him apart as a great coworker.",
  },
  {
    id: 4,
    name: "Carlos Crinejo",
    es: {
      title: "Agente de Compras",
      workRelation: "Compañero de Equipo",
      referenceText:
        "Trabajé con Sergio en Systel. Es un excelente profesional que está dispuesto a trabajar en equipo y aportar constantemente nuevas ideas al grupo. Con una gran personalidad y sentido del humor, mejora su capacidad para trabajar, haciendo que todos los asuntos fluyan sin ningún inconveniente. Proporcionó innumerables mejoras económicas al buscar componentes en nuevos proveedores en el extranjero gracias a su búsqueda constante de ellos. Su objetivo siempre fue superarse como profesional, lo que resultó en acciones altamente positivas para la empresa. ¡Espero tener a Sergio como colega de nuevo en el futuro!",
    },
    title: "Purchasing agent",
    workRelation: "Teamate",
    linkedinProfile: "https://www.linkedin.com/in/crinejo-carlos-2b248531/",
    image: "carlos",
    referenceText:
      "I worked with Sergio at Systel He is an excellent professional who is willing to work in a team and continuously contributes new ideas to the group. With a great personality and sense of humor, he enhances his ability to work, making all issues flow without any inconvenience. He provided countless economic improvements by sourcing components from new suppliers abroad thanks to his continuous search for them. His goal was always to improve himself as a professional, which resulted in highly positive actions for the company. I hope to have Sergio as a colleague again sometime in the future!",
  },
  {
    id: 5,
    name: "Marcelo Ramón Gonzalez",
    es: {
      title:
        "Máster en Cadena de Suministro en ENEB - Escuela de Negocios Europea de Barcelona",
      workRelation: "Gerente",
      referenceText:
        "He trabajado con Sergio desde 2016 y constantemente me ha impresionado con su capacidad para trabajar en equipo y su experiencia en el área de compras. Ha logrado todos los objetivos en el área, especialmente en la reducción de costos y la mejora de la eficiencia de nuestra cadena de suministro. Además, ha desempeñado funciones en el comercio exterior, un área en la que tiene un amplio conocimiento. Sergio es un excelente profesional y aún mejor persona. Es altamente recomendado, y siempre me gustaría tener personas como él en mi equipo.",
    },
    title:
      "Master of supply chain en ENEB - Escuela de Negocios Europea de Barcelona",
    workRelation: "Manager",
    linkedinProfile:
      "https://www.linkedin.com/in/marcelo-ramon-gonzalez-09682b52/",
    image: "marcelo",
    referenceText:
      "I have worked with Sergio since 2016 and he has constantly impressed me with his ability to work in a team and his experience in the purchasing area. He has achieved all the goals in the area, especially in reducing costs and improving the efficiency of our supply chain. In addition, he has performed functions in foreign trade, an area where he has extensive knowledge. Sergio is an excellent professional and even better person. He is highly recommended, and I would always like to have people like him on my team.",
  },
];
